"use client";

import { motion } from "framer-motion";
import { CreditCard } from "lucide-react";
import { InfoBox } from "@/components/ui/info-box";
import { containerVariants, itemVariants } from "@/lib/animation-variants";

export default function PaymentInfo() {
  return (
    <section className="bg-gothia-green px-4 pb-20 sm:px-6 lg:px-8">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="mx-auto max-w-3xl">
        <motion.div variants={itemVariants}>
          <InfoBox
            variant="info"
            icon={<CreditCard className="h-5 w-5" />}
            title="Bezahlung vor Ort">
            Während des gesamten Stiftungsfestes sind sowohl Karten- als auch
            Barzahlung möglich – dies gilt an allen Veranstaltungsorten, also im
            Gothenhaus, im Alten Rathaus und im Hotel Dormero. Wir bitten euch,
            nach Möglichkeit mit Karte zu zahlen.
          </InfoBox>
        </motion.div>
      </motion.div>
    </section>
  );
}
